import { NgModule } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import { LayoutRoutingModule } from './layout-routing.module';
import {HeaderModule} from './header/header.module';
import {SidebarModule} from './sidebar/sidebar.module';
import { LayoutComponent } from './layout.component';
import { Apollo } from 'apollo-angular';
import { GraphQLModule } from '@shared/modules/graphql.module';
import { SubmenuComponent } from './submenu/submenu.component';
import {CdkAccordion, CdkAccordionItem} from "@angular/cdk/accordion";
import {ReactiveFormsModule} from "@angular/forms";
import {MatTooltip} from '@angular/material/tooltip';
import {ButtonComponent} from '@shared/components/button/button.component';
import {BkButton} from '@brickclay-org/ui';
@NgModule({
  declarations: [
    LayoutComponent,
    SubmenuComponent
  ],
  imports: [
    CommonModule,
    LayoutRoutingModule,
    HeaderModule,
    SidebarModule,
    GraphQLModule,
    CdkAccordion,
    BkButton,
    CdkAccordionItem,
    MatTooltip,
    NgOptimizedImage,
    ReactiveFormsModule,
    ButtonComponent,
  ],
  providers:[Apollo]

})
export class LayoutModule { }
